import { render, staticRenderFns } from "./synergy.vue?vue&type=template&id=09ec142d&scoped=true"
import script from "./synergy.vue?vue&type=script&lang=js"
export * from "./synergy.vue?vue&type=script&lang=js"
import style0 from "./synergy.vue?vue&type=style&index=0&id=09ec142d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec142d",
  null
  
)

export default component.exports